// src/pages/NavDetails/productData.js
import question_generator from "../../assets/images/question_generator.jpg";
import convertational_score from "../../assets/images/convertational_score.jpg";
import analytics from "../../assets/images/analytics.jpg";
import export_integration from "../../assets/images/export_integration.jpg";

export const faqs = [
  {
    question: "How long does it take to create an assessment?",
    answer:
      "With our AI-assisted tools, you can create a fully functional assessment in just a few minutes—complete with questions, scoring, and delivery options.",
  },
  {
    question: "Can I customize the question types?",
    answer:
      "Absolutely! You can create multiple-choice, descriptive, or even custom question formats—fully tailored to your subject and assessment goals.",
  },
  {
    question: "Is AI grading accurate and fair?",
    answer:
      "Yes. Our AI scoring engine is trained for consistency and fairness, ensuring accurate results across long-form and objective answers—without human bias.",
  },
  {
    question: "Can I export results in any format I want?",
    answer:
      "Yes, you can export results to Excel or PDF in detail and also can instantly download your certificates.",
  },
];
export const simplify = [
  {
    problem: "Building question papers takes forever...",
    solution: "Auto-generate quizzes in seconds with AI."
  },
  {
    problem: "Manual grading eats hours and has errors...",
    solution: "AI auto-grades 99% instantly and accurately..."
  },
  {
    problem: "Students do not get their feedback instantly…",
    solution: "Real-time scoring and insights after every test."
  },
  {
    problem: "Scaling any assessments is a nightmare…",
    solution: "Launch to 10 or 10,000 with the same ease."
  }
];
export const carousel = [
  {
    id: 1,
    title: "Question Generator",
    img: question_generator,
    desc: "Save hours with our AI-powered Question Generator. Instantly create multiple-choice, descriptive, or custom question sets based on your subject or content. Whether you're prepping a quiz or a full exam, generate quality, relevant questions in seconds—with full control to edit, tweak, and customize before publishing.",
  },
  {
    id: 2,
    title: "Conversational AI Scoring",
    img: convertational_score,
    desc: "Ditch manual grading with intelligent, conversational AI scoring. Our system evaluates long-form answers, short responses, or subjective inputs with high accuracy—just like a human, but faster. Provide immediate, meaningful feedback and consistent scoring at scale, all while maintaining fairness, speed, and transparency in every assessment.",
  },
  {
    id: 3,
    title: "Analytics & Leaderboards",
    img: analytics,
    desc: "Turn raw data into actionable insights. Get a clear view of individual and group performance, question-wise accuracy, and time spent per test. Built-in leaderboards motivate participants and bring a gamified edge to assessments—perfect for classrooms, competitions, or team-based learning environments.",
  },
  {
    id: 4,
    title: "Integrations & Exports",
    img: export_integration,
    desc: "Plug in your learning materials with ease. Export results to Excel/PDF. Our platform ensures your data is portable, secure, and ready for deeper analysis, reporting, or system-wide updates.",
  },
];